import isAfterDate from "validator/lib/isAfter";
import type { IValidatorParams } from "@edaz/services/baseValidationService";

export type IsAfterOptions = IsAfterOptions1 | IsAfterOptions2;

interface IsAfterOptions1 {
  condition: (entity: any) => Date | undefined;
  after?: undefined;
}

interface IsAfterOptions2 {
  condition?: undefined;
  after: Date;
}

export default function isAfter(value: Date | undefined, options: IsAfterOptions, params?: IValidatorParams) {
  if (value) {
    if (options.after) {
      return isAfterDate(value?.toISOString(), options.after.toISOString());
    } else if (options.condition) {
      const after = options.condition(params?.entity);
      if (after) {
        return isAfterDate(value?.toISOString(), after.toISOString());
      }
    }
  }

  return true;
}
